import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { IoMdClose, IoMdInformationCircleOutline } from "react-icons/io";
import { BsSearch } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import "./style.css";
import { LoginContext } from '../../../../contexts/login_context';
import { dismissToast, showError, showWait } from '../../../../services/toast';
import DataTable, { TableColumn } from 'react-data-table-component';
import BootyPagination from '../../../../components/Pagination';
import NewWarning from '../../../../components/newWarning';
import ExportDetail from '../../../../components/ExportDetail';
import { useSearchPagination } from '../../../../contexts/Ncm&Gpc_context';
import { buildVerifyCompanyNcmRows } from '../../../../services/exportFileFrontEndVerifyCompanyNcm';
import { exportFileTest } from '../../../../services/exportFileFrontEndGTIN';
import { ConsultaSimilaridade, ContagemSimilaridade } from '../../../../services/ConsultaSimilaridade';
import TableSimilaridade from '../../../../components/tableSimilaridade';
import { exportFileTestSimilaridade } from '../../../../services/exportFileFrontEndSimilaridade';

const SearchOneSimilares = () => {
  const [view, setView] = useState({ error: false, content: false });
  const [errorTitle, setErrorTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const { jwt } = useContext(LoginContext);
  const [code, setCode] = useState("");
  const [selectedSimilarities, setSelectedSimilarities] = useState<string[]>([]);
  const myRef: any = useRef();
  const [dataPrepared, setdataPrepared] = useState<any>();
  const [pages, setPages] = useState<number[]>([]);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const { Datapagina, setStepMaganer, stepMaganer, setSelectRows, setDataAll, setDatapagina } = useSearchPagination();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenBack, setIsModalOpenBack] = useState(false);
  const [ipsOpenModalConfirm, setIpsOpenModalConfirm] = useState(false);
  const [lastFilters, setLastFilters] = useState<any | null>(null);
  const [limitConfirmation, setLimitConfirmation] = useState<any | null>(null);

  const navigate = useNavigate();
  type Row = { GTIN?: string | number | null };
  const LS_KEY = 'searchMany:pendingGtins';
  const [selectedGtins, setSelectedGtins] = useState<string[]>([]);

  const similarityLabels: Record<string, string> = {
    'GTIN_KIT': 'Conteúdo Líquido',
    'MARCA': 'Marca'
  };

  const parseNumber = (value: any): number | null => {
    if (value === null || value === undefined || value === '') return null;

    const normalized = String(value).replace(',', '.');
    const number = Number(normalized);

    return Number.isNaN(number) ? null : number;
  };

const formatConteudoLiquido = (row: any): string => {
  const valor = parseNumber(row.CONT_LIQUIDO);

  const unidade = (
    row.UNIDADE_MEDIDA ||
    row.UNIDADE_MEDIDA_CONTEUDO ||
    row.UNIDADE ||
    row.MEDIDA ||
    ''
  ).toString().trim();

  if (valor === null) return '---';
  
  const unidadeFinal = unidade || 'L';
  const unidadeUpper = unidadeFinal.toUpperCase();

  if (
    unidadeUpper === 'L' ||
    unidadeUpper === 'LT' ||
    unidadeUpper === 'LITRO' ||
    unidadeUpper === 'LITROS'
  ) {
    const valorEmMl = valor * 1000;
    return `${valorEmMl} ml`;
  }

  if (
    unidadeUpper === 'ML' ||
    unidadeUpper === 'MILILITRO' ||
    unidadeUpper === 'MILILITROS'
  ) {
    return `${valor} ml`;
  }

  return `${valor} ${unidadeFinal}`;
};

  useEffect(() => {
    try { Modal.setAppElement('#root'); } catch {}
    setStepMaganer("none");
  }, []);

  const handleRequireConfirmation = ({ filtros, raw }: { filtros: any; raw: any }) => {
    const qtdDisponivel = Number(raw?.qtdDisponivel ?? 0);

    if (qtdDisponivel <= 0) {
      showError(
        'Sua busca excede o número disponível de consulta. Por favor, verificar a quantidade de consultas restantes na área de administrador.'
      );
      return;
    }

    setLastFilters(filtros);
    setLimitConfirmation(raw);
    setIpsOpenModalConfirm(true);
  };

  const handleConfirmarConsulta = async () => {
    // 1. Fecha o modal de confirmação
    setIpsOpenModalConfirm(false);

    // 2. Tenta pegar a página do lastFilters. 
    // Se o lastFilters falhar ou vier quebrado, pega a página atual selecionada no state (selectedPages[0]).
    const pageToFetch = (lastFilters && lastFilters.page) ? lastFilters.page : (selectedPages[0] || 1);

    // 3. Dispara a nova requisição para o backend passando confirmar = true
    await togglePage(pageToFetch, true); 
  };

  const handleSelectedRowsChange = (state: { selectedRows: Row[] }) => {
    const gtins: string[] = Array.from(
      new Set(
        (state.selectedRows ?? [])
          .map(r => (r.GTIN ?? '').toString())
          .map(s => s.replace(/\D+/g, ''))
          .filter(Boolean)
      )
    ).slice(0, 100);

    localStorage.setItem(LS_KEY, JSON.stringify(gtins));
    setSelectedGtins(gtins);
    setSelectRows?.(gtins);
  };

  const handleContinuar = () => {
    if (!Datapagina || Datapagina.length === 0) {
      showError("Não há dados para exportar.");
      return;
    }
    
    exportFileTestSimilaridade(Datapagina, 'xls'); 

    if (!localStorage.getItem(LS_KEY)) {
      localStorage.setItem(LS_KEY, JSON.stringify(selectedGtins));
    }
    navigate('/search-many');
  };

  const handleContinuarBackList = () => {
    exportFileTestSimilaridade(Datapagina, 'xls'); 
    
    if (!localStorage.getItem(LS_KEY)) {
      localStorage.setItem(LS_KEY, JSON.stringify(selectedGtins));
    }
    searchCode();
    setIsModalOpenBack(false);
  };

  const openChangeScreenModal = () => setIsModalOpen(true);
  const openChangeScreenModalBack = () => setIsModalOpenBack(true);
  const closeChangeScreenModal = () => setIsModalOpen(false);
  const closeChangeScreenModalBack = () => setIsModalOpenBack(false);
  const closeChangeScreenModalConfirm = () => setIpsOpenModalConfirm(false);

  const handleConfirmChangeScreen = () => {
    setStepMaganer('table');
    setIsModalOpen(false);
  };

  const handleConsultarDadosProduto = () => {
    if (!selectedGtins || selectedGtins.length === 0) {
      showError('Selecione pelo menos um GTIN na tabela para consultar os dados do produto.');
      return;
    }
    openChangeScreenModal();
  };

  const togglePage = async (page: number, confirmar = false) => {
    setSelectedPages([page]);
    const toastId = showWait('Aguarde, carregando os dados da página...');
    setIsDisabled(true);
    
    const hasConteudoLiquido = selectedSimilarities.includes('GTIN_KIT');
    const hasMarca = selectedSimilarities.includes('MARCA');

    try {
      const result = await ConsultaSimilaridade(jwt, code, hasConteudoLiquido, hasMarca, page, confirmar);
      
      dismissToast(toastId);
      setIsDisabled(false);

      if (result?.success && result?.result) {
        const rawData = result.result?.data || result.result;

        if (rawData.requerConfirmacao || result.result.requerConfirmacao) {
          const limitInfo = rawData.requerConfirmacao ? rawData : result.result;
          handleRequireConfirmation({ filtros: { page }, raw: limitInfo });
          return;
        }

        let dataArray: any[] = [];
        if (Array.isArray(rawData)) {
          dataArray = rawData;
        } else if (rawData && typeof rawData === 'object') {
          dataArray = Object.values(rawData).flat();
        } else {
          dataArray = [rawData];
        }

        const limitObj = dataArray.find((x: any) => x && typeof x === 'object' && 'mensagemLimite' in x);
        const produtos = dataArray.filter((x: any) => !(x && typeof x === 'object' && 'mensagemLimite' in x));

        if (produtos.length === 0 && limitObj?.mensagemLimite) {
          showError(limitObj.mensagemLimite);
          return;
        }

        setdataPrepared(produtos);
        setDatapagina(produtos);
        setStepMaganer('table');

        setTimeout(() => {
          if (myRef?.current) {
            myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);

        if (limitObj?.mensagemLimite) {
          showError(limitObj.mensagemLimite);
        }

      } else {
        showError("Não foi possível carregar os dados desta página.");
      }
    } catch (error) {
      dismissToast(toastId);
      setIsDisabled(false);
      showError("Erro inesperado ao buscar a página.");
    }
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    if (selectedValue && !selectedSimilarities.includes(selectedValue)) {
      setSelectedSimilarities([...selectedSimilarities, selectedValue]);
    }
    event.target.value = '';
  };

  const handleRemoveSimilarity = (valToRemove: string) => {
    setSelectedSimilarities(selectedSimilarities.filter(val => val !== valToRemove));
  };

  const formatTipoGtin = (tipo: any): string => {
    if (!tipo) return '---';
    return String(tipo).replace(/^"+|"+$/g, '').trim().replace('_', '-');
  };

  const customStyles = {
    rows: {
      style: {
        display:'flex', justifyContent: 'space-around', minHeight: '50px',
        fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: "0.94rem", color: "#002c6c",
        '&:nth-of-type(odd)': { backgroundColor: '#ffffff' },
        '&:nth-of-type(even)': { backgroundColor: '#e4e8ea' }
      },
    },
    headRow: {
      style:{ display: 'flex', alignItems:'center', justifyContent: 'space-around', borderTop:'1px solid #ccc' }
    },
    TableCell:{ style:{ color:'red' }},
    headCells: {
      style: {
        paddingLeft: '6px', paddingRight: '6px',
        fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: "0.94rem", color: "#002c6c",
      },
    },
    cells: {
      style: { paddingLeft: '6px', paddingRight: '6px', fontWeight: "500 !important", display: 'flex' },
    },
    pagination: {
      style: {
        color: "#002c6c",
        fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: '0.94rem', minHeight: '56px',
      },
    },
  };

  const columns: TableColumn<any>[] = [
    { 
      name: 'GTIN', 
      selector: (row: any) => row.GTIN || '---', 
      sortable: true, 
      wrap: true, 
      center: true, 
      width: '160px' 
    },
    { 
      name: '% Similaridade', 
      selector: (row: any) => row.SIM_COS != null ? `${(Number(row.SIM_COS) * 100).toFixed(2)}%` : '---', 
      sortable: true, 
      center: true, 
      width: '140px' 
    },
    { 
      name: 'Descrição do Produto', 
      selector: (row: any) => (row.DESCRICAO || '---').toString().trim(), 
      minWidth: '220px', 
      wrap: true,
      sortable: true 
    },
    { 
      name: 'Marca', 
      selector: (row: any) => row.MARCA || '---', 
      sortable: true, 
      wrap: false 
    },
    { 
      name: 'Conteúdo Líquido', 
      selector: (row: any) => formatConteudoLiquido(row), 
      sortable: true, 
      wrap: false 
    },
    { 
      name: 'Tipo de GTIN', 
      selector: (row: any) => formatTipoGtin(row.TIPO_GTIN), 
      maxWidth: '150px', 
      wrap: false, 
      sortable: true 
    },
  ];

  const validate = () => {
    let message = '';
    let titleMessage = '';
    let error = false;

    setView({ error: false, content: false });

    if (!code || code.trim() === '') {
      error = true;
      titleMessage = 'Nenhum código foi digitado no campo de busca';
      message = 'Por favor, informe ao menos um código para consulta';
    } else if (code.trim().length < 8) {
      error = true;
      titleMessage = 'O número informado é curto';
      message = 'Por favor, informe um código com pelo menos 8 dígitos';
    }

    return { message, titleMessage, error };
  };

  const searchCode = async () => {
    setStepMaganer('none');
    const valid = validate();
    
    if (!valid.error) {
      const toastId = showWait('Aguarde, enquanto realizamos sua pesquisa');
      setIsDisabled(true);

      const hasConteudoLiquido = selectedSimilarities.includes('GTIN_KIT');
      const hasMarca = selectedSimilarities.includes('MARCA');

      try {
        const contagem = await ContagemSimilaridade(jwt, code, hasConteudoLiquido, hasMarca);

        dismissToast(toastId);
        setIsDisabled(false);

        if (contagem?.success && contagem?.result) {
          setView({ error: false, content: true });
          
          const { count, pages, userSearchesForGtin } = contagem.result;

          if (pages && Array.isArray(pages) && pages.length > 0) {
            setPages(pages);
          } else if (count > 0) {
            setPages(Array.from({ length: count }, (_, i) => i + 1));
          } else {
            setPages([]);
          }

          setSelectedPages([]);

          if (userSearchesForGtin) {
            setDataAll?.(userSearchesForGtin);
          }
          
          setStepMaganer('list');

          setTimeout(() => {
            if (myRef?.current) {
              myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }, 100);

        } else {
          setView({ error: true, content: false });
          setErrorTitle('Código não encontrado');
          setErrorMessage("Por favor, verifique se há erros de digitação e tente novamente.");
        }
      } catch (err: any) {
        dismissToast(toastId);
        setIsDisabled(false);
        setView({ error: true, content: false });
        setErrorTitle("Erro na consulta");
        setErrorMessage("Erro inesperado na consulta.");
      }
    } else {
      setView({ error: true, content: false });
      setErrorTitle(valid.titleMessage);
      setErrorMessage(valid.message);
      showError(valid.message);
    }
  };

  return (
    <>
      <div className='bg-color-ui-1'>
        <div className='container'>
          <div className='row customWidth bg-color-white px-4 rounded-lg'>
            <div className='col-12 col-md-12 mb-5'>
              <form className='customForm' onSubmit={(e) => { e.preventDefault(); searchCode(); }}>
                <div className='custom-container-input' style={{display:'flex', justifyContent:'flex-end'}}>
                  <div className='custom-border5GLN'>
                    <label className='container_my_input_custom custom-height-container-input'>
                      <BsSearch />
                      <input
                        id='inputIdGLN'
                        placeholder="Digite um número de código de barra (GTIN)"
                        onChange={({ target }) => setCode(target.value)}
                        value={code}
                        className="especial_input"
                        style={{outline:'none', border: 'none'}}
                        disabled={isDisabled}
                      />
                    </label>
                  </div>
                  <div>
                    <button type="submit" className="custom-button-especial" disabled={isDisabled}>
                      Buscar
                    </button>
                  </div>
                </div>
              </form>    
              
              <div style={{ marginTop: "5px" }}>
                <span className="customSpan">
                  Exemplo:{" "}
                  <button 
                    disabled={isDisabled} 
                    onClick={() => setCode("9506000140445")} 
                    style={{ background: 'none', border: 'none', padding: 0, color: '#0c9ae3', textDecoration: 'underline', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  >
                    9506000140445
                  </button>
                </span>
              </div>

              <div className="row" style={{ marginTop: '10px' }}>
                <p style={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                  Selecione o filtro de Similaridade
                  <span className="custom-tooltip-container">
                    <IoMdInformationCircleOutline size={18} style={{ marginLeft: '5px', color: '#002c6c', cursor: 'pointer' }} />
                    <span className="custom-tooltip-text">
                      Mostra o quanto os produtos são semelhantes entre si, facilitando a comparação por marca e conteúdo líquido.
                    </span>
                  </span>
                </p>
              </div>
              
              <div className="form-group mb-0">
                {selectedSimilarities.length < 2 && (
                  <select
                    disabled={isDisabled}
                    style={{ height: '44px', padding: '0px', paddingLeft: '10px' }}
                    className="form-control"
                    onChange={handleSelectChange}
                    value={''}
                  >
                    <option disabled value={''}>Selecione uma opção</option>
                    {!selectedSimilarities.includes('GTIN_KIT') && <option value="GTIN_KIT">Conteúdo Líquido</option>}
                    {!selectedSimilarities.includes('MARCA') && <option value="MARCA">Marca</option>}
                  </select>
                )}

                {selectedSimilarities.length > 0 && (
                  <div style={{ 
                    display: 'flex', gap: '10px', flexWrap: 'wrap', padding: '10px', border: '1px solid #ced4da', 
                    borderRadius: '5px', marginBottom: '10px', minHeight: '50px', alignItems: 'center', marginTop: '10px' 
                  }}>
                    {selectedSimilarities.map((val) => (
                      <div key={val} style={{ 
                        display: 'flex', alignItems: 'center', backgroundColor: '#f8f9fa', padding: '6px 12px', 
                        borderRadius: '8px', border: '1px solid #e1e3e6', fontSize: '13px', fontWeight: 600, 
                        color: '#002c6c', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' 
                      }}>
                        {similarityLabels[val]}
                        <span onClick={() => { if (!isDisabled) handleRemoveSimilarity(val) }} style={{ marginLeft: '10px', cursor: isDisabled ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center' }}>
                          <IoMdClose size={16} color={isDisabled ? "#ccc" : "#000"} />
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div ref={myRef}></div>
          </div>
        </div>
      </div>

      {stepMaganer === "list" && pages.length > 0 && (
        <div className="col-12 mt-4" style={{ maxWidth: '1100px', padding: 0 }}>
          <div className="bg-color-ui-1 pb-5 wp-home">
            <div className="container bg-color-white py-5 px-4 rounded-lg" style={{width:'102%'}} ref={myRef}>
              <TableSimilaridade
                pages={pages}
                selected={selectedPages}
                onToggle={togglePage}
                code={code}
                hasConteudoLiquido={selectedSimilarities.includes('GTIN_KIT')}
                hasMarca={selectedSimilarities.includes('MARCA')}
                onRequireConfirmation={handleRequireConfirmation} 
                isDisabled={isDisabled}
                setIsDisabled={setIsDisabled}
              />
            </div>
          </div>
        </div>
      )}

      {stepMaganer === "table" && Datapagina && Datapagina.length > 0 && ( 
        <div className="col-12 mt-4" style={{ maxWidth: '1100px', padding: 0 }}>
          <div className="bg-color-ui-1 wp-home">
            <div className="bg-color-ui-1 pb-5 wp-home mt-4">
              <div className="container">
                <div style={{ paddingBottom: 10, fontSize: '14pt', color: '#0c9ae3', cursor: isDisabled ? 'not-allowed' : 'pointer' }} onClick={() => { if (!isDisabled) openChangeScreenModalBack() }}>
                  &lt; Voltar para o resultado de busca
                </div>
              </div>
            </div>

            <div className="bg-color-white px-4 rounded-lg" style={{ width: '100%' }}>
              <div className="row">
                <NewWarning type="success" showpick={false} title="" text={`Sua consulta retornou ${Datapagina.length} GTINs. Caso queira consultar os dados de produtos, por favor, selecione os GTINs e clique no botão "Consultar os dados do produto". <br><br> O que é o atributo Similaridade?
A similaridade refere-se ao grau de correspondência entre as informações pesquisadas e os resultados encontrados, sendo que a ferramenta disponibiliza apenas itens onde a similaridade seja igual ou superior a 50%.`} />
              </div>

              <div className="row-custom" style={{ width: '100%' }}>
                <div className="col-12 col-md-6 col-lg-8">
                  <h2 style={{ marginTop: 0, marginBottom: '0.5rem' }}>Resultado da Pesquisa</h2>
                  <p className="little_text">Selecione os GTINs que gostaria de consultar os dados do produto</p>
                </div>
                <div style={{ marginTop: '15px', marginRight:'70px', width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div className="col-12 col-md-6 col-lg-4">
                    {view.content && (<ExportDetail dataPrepared={Datapagina} itemType={'SIMILARIDADE'} />)}
                  </div>
                  <button type="button" className="custom-button-especial" style={{fontSize:'14px', width:'27%'}} disabled={isDisabled} onClick={handleConsultarDadosProduto}>
                    Consultar os dados do produto
                  </button>
                </div>
              </div>
            </div>

            <div className="container px-0 bg-color-white rounded-lg">
              <DataTable
                columns={columns}
                data={Datapagina}
                pagination
                responsive
                selectableRows
                selectableRowsHighlight
                noDataComponent="Sem registros para exibir"
                highlightOnHover
                onSelectedRowsChange={handleSelectedRowsChange}
                customStyles={customStyles}
                paginationComponent={BootyPagination}
              />
            </div>
          </div>
        </div>
      )} 
      
      <Modal isOpen={isModalOpen} contentLabel="Selected Option" style={{ overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#262626CC", zIndex: 1000 }, content: { maxWidth: "485px", height: "270px", marginTop: "5%", marginBottom: 0, marginLeft: "auto", marginRight: "auto", zIndex: 1000, border: "1px solid #ccc", background: "#fff", overflow: "auto", WebkitOverflowScrolling: "touch", borderRadius: "20px", outline: "none", padding: "10px" }}}>
        <div style={{ padding: "0.5rem" }}>
          <span onClick={closeChangeScreenModal} style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }} aria-label="Fechar modal" title="Fechar">
            <IoMdClose />
          </span>
          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive" style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "180px", textAlign: "justify" }}>
                      <div style={{ width: "100%", display: "flex", flexDirection: "column", marginBottom: "20px" }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>Aviso de redirecionamento</span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Você será redirecionado para a aba de consulta múltipla e não poderá retornar à tela anterior. Ao clicar em <strong>Continuar</strong>, a consulta atual será baixada.
                        </div>
                      </div>
                    </div>
                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button style={{ maxWidth: "170px", marginRight: "10px" }} className="btn btn-outline-primary custom-fontSize" onClick={handleConfirmChangeScreen}>Cancelar</button>
                      </div>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button style={{ maxWidth: "170px" }} className="btn btn-primary custom-fontSize" onClick={handleContinuar}>Continuar</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal isOpen={isModalOpenBack} contentLabel="Selected Option" style={{ overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#262626CC", zIndex: 1000 }, content: { maxWidth: "485px", height: "270px", marginTop: "5%", marginBottom: 0, marginLeft: "auto", marginRight: "auto", zIndex: 1000, border: "1px solid #ccc", background: "#fff", overflow: "auto", WebkitOverflowScrolling: "touch", borderRadius: "20px", outline: "none", padding: "10px" }}}>
        <div style={{ padding: "0.5rem" }}>
          <span onClick={closeChangeScreenModalBack} style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }} aria-label="Fechar modal" title="Fechar">
            <IoMdClose />
          </span>
          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive" style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "180px", textAlign: "justify" }}>
                      <div style={{ width: "100%", display: "flex", flexDirection: "column", marginBottom: "20px" }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>Atenção!</span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Ao voltar para a lista de GTINs, o download da lista que você acabou de consultar será iniciado automaticamente.
                        </div>
                      </div>
                    </div>
                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button style={{ maxWidth: "170px", marginRight: "10px" }} className="btn btn-outline-primary custom-fontSize" onClick={()=>{setIsModalOpenBack(false)}}>Cancelar</button>
                      </div>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button style={{ maxWidth: "170px" }} className="btn btn-primary custom-fontSize" onClick={handleContinuarBackList}>Continuar</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={ipsOpenModalConfirm}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "485px",
            height: "270px",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}
      >
        <div style={{ padding: "0.5rem" }}>
          <span
            onClick={closeChangeScreenModalConfirm}
            style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive"
                       style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize"
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           justifyContent: "center",
                           alignItems: "center",
                           height: "180px",
                           textAlign: "justify",
                         }}>
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                         Atenção!
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Identificamos que a quantidade de códigos disponível na página selecionada é superior ao limite disponível da empresa. Ao clicar em "Continuar", a consulta será realizada, mas <strong>será entregue apenas a quantidade disponível do limite da sua empresa.</strong>
                        </div>
                      </div>
                    </div>

                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop:10}}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px", marginRight: "10px" }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={()=>{setIpsOpenModalConfirm(false)}}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px" }}
                          className="btn btn-primary custom-fontSize"
                          onClick={handleConfirmarConsulta}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal>
    </>
  );
};

export default SearchOneSimilares;